import Features from './features';
import Common from './common';
import Modals from './modals';
import Pages from './pages';
import Alerts from './alerts';
import Components from './components';
import Shared from './shared';

export default {
  Features,
  Common,
  Modals,
  Pages,
  Alerts,
  Components,
  Shared,
};
